var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.cssClass},[_c('use',{attrs:{"xlink:href":_vm.icon.symbol}})])}
var staticRenderFns = []

export { render, staticRenderFns }